import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var messageListRes;
export const messageListTodo = createAsyncThunk('messageList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/view_asked_questions',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return messageListRes = res.data
    } catch (error) {
        return messageListRes = error.response.data
    }
})


const messageListSlice = createSlice({
    name: 'messageList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(messageListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('messageList', state.data)
            }
        });
        builder.addCase(messageListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default messageListSlice.reducer; 